import { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import creditRequestApi from "../../../../../api/creditRequestApi";

const CreditRequestUser = ({ onSuccess }) => {
  const navigate = useNavigate();
  const [requestedCredits, setRequestedCredits] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const userEmail = user?.userEmail;
  const [mobileNumber, setMobileNumber] = useState(
    user?.mobileNumber || user?.phone || "",
  );
  const [loading, setLoading] = useState(false);
  const [showTransactionReport, setShowTransactionReport] = useState(false);
  const handleSubmitRequest = async () => {
    if (!requestedCredits || parseInt(requestedCredits, 10) <= 0) {
      toast.warn("Please enter a valid number of credits.");
      return;
    }

    if (!userEmail) {
      toast.error("User email not found. Please log in again.");
      return;
    }

    if (!mobileNumber || mobileNumber.trim() === "") {
      toast.warn("Please enter a valid mobile number.");
      return;
    }

    setLoading(true);

    try {
      const response = await creditRequestApi.saveCreditPricing({
        email: userEmail,
        credits: parseInt(requestedCredits, 10),
        mobileNumber: mobileNumber,
        frymeType: "PERSONAL",
      });

      console.log("Credit request response:", response);

      toast.success("Credit request submitted successfully!", {
        onClose: () => onSuccess?.(),
      });

      setRequestedCredits("");
      setMobileNumber(user?.mobileNumber || user?.phone || "");
    } catch (error) {
      console.error("Error submitting credit request:", error);

      toast.error(
        error.response?.data?.message ||
          "Please wait while we process your request. This franchise currently has no available Frymes. Please try again after some time.",
      );
    } finally {
      // spinner stops here after toast/API response
      setLoading(false);
    }
  };
  return (
    <>
      {/* <div className="d-flex justify-content-between align-items-center mb-3"> */}
        {/* <h4 md={6} className="mb-0"> */}
          {/* <p>Credit price unit {creditPiceUnit}</p> */}
          {/* <p>
            <strong>Total credits:</strong> {transactions?.creditBought || 0}{" "}
            &nbsp;||&nbsp;
            <strong>Used Credits:</strong> {transactions?.usedCredit || 0}{" "}
            &nbsp;||&nbsp; <strong>Balance credits:</strong>{" "}
            {transactions?.balanceCredit || 0}
          </p> */}
        {/* </h4> */}
        {/* <Button
          variant="info"
          onClick={() =>
            navigate(
              "/dashboard/creditPassBook/transactionReport",
            )
          }
        >
          Transaction Report
        </Button> */}
      {/* </div> */}

      {/* <Card className="p-3 mt-3">
        <h5>📘 How Credits Work</h5>
        <ul>
          <li>
            Every document you send costs <strong>20 credits</strong>.
          </li>
          <li>Ensure you have enough balance to send documents.</li>
          <li>
            You can’t send documents if your balance is below the minimum
            required credits (less than 20).
          </li>
          <li>If you need more, you can request credits from admin.</li>
        </ul>
      </Card> */}

      {/* <Card className="p-3"> */}
      
        <Form>
          <Form.Group controlId="creditRequest">
            <Form.Label>
              How many credits do you want?{" "}
              <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter number of credits"
              value={requestedCredits}
              onChange={(e) => setRequestedCredits(e.target.value)}
              min={1}
            />
          </Form.Group>

          <Form.Group controlId="mobileNumber" className="mt-3">
            <Form.Label>
              Mobile Number <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter mobile number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
            />
          </Form.Group>
          <br />
          <Form.Text className=" mt-3 text-muted"style={{ fontSize: "13px", lineHeight: "1.6" }}>
            ⏳ Please allow up to <strong>24 hours</strong> for the admin team
            to review your credit request. During this time, an administrator
            may contact you to discuss and approve your Fryme request.
            <br />
            <br />
            If you do not receive a call within 24 hours, please contact us at{" "}
            <a href="mailto:support@signbook.co">support@signbook.co</a>.
          </Form.Text>
          <br />
         
          <Button
            type="button"
            className="mt-3"
            variant="success"
            onClick={handleSubmitRequest}
            disabled={
              loading ||
              !requestedCredits ||
              parseInt(requestedCredits, 10) <= 0 ||
              !mobileNumber ||
              mobileNumber.trim() === ""
            }
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Please wait...
              </>
            ) : (
              "Submit Request"
            )}
          </Button>
        </Form>
      {/* </Card> */}

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default CreditRequestUser;
